module.exports = __webpack_public_path__ + "img/grondeigendom_rws.b8119844.png";